/**
 * Model for file uploads and downloads.
 *
 * FILE UPLOAD USAGE:
 * When you are doing a file upload, the File (See https://developer.mozilla.org/en-US/docs/Web/API/File) should be
 * set on the fileObj field and the content field should be populated with JSON Array of bytes from the File object.
 * The downloadUrl should be ignored.
 *
 * FILE DOWNLOAD USAGE:
 * When you are doing a file download from an API, do NOT populate the File object (fileObj field), but instead just specify
 * the downloadUrl. You may populate the content field with the Json bytes when the download completes, but it is
 * not recommended as a file download should not be stored in local memory.
 */
export default class FileItem {
	/**
	 *
	 * @param {String} fileName the file name should be considered as a unique value if there is an array of FileItems.
	 * @param {Number} fileSize
	 * @param {String} fileType
	 * @param {String} content - Json array of byte numbers, for example "[76,111,114,101,109,32,73,112]"
	 * @param {File} fileObj - Optional. Use this field if you have the entire File object from a file upload.
	 * @param {String} downloadUrl - Optional. Use this field if you do not have the entire File object in fileObj. Mostly
	 * used for file downloads from an API
	 * @param {String} remoteFileId - Optional. This field should only be populated if the file is already uploaded in the
	 * remote repository
	 * @param {Boolean} isUploadError - Optional. Use this field to indicate if an error occurred when the file was uploaded to a remote server
	 */
	constructor(fileName, fileSize, fileType, content, fileObj, downloadUrl, remoteFileId, isUploadError) {
		this.fileName = fileName;
		this.fileSize = fileSize;
		this.fileType = fileType;

		// content is the json the bytes of the file
		this.content = content;

		this.fileObj = null;
		if (fileObj instanceof File) {
			this.fileObj = fileObj;
		}

		this.downloadUrl = downloadUrl;
		this.remoteFileId = remoteFileId;
		this.uploadError = isUploadError;
	}
}
